export const TAN_TABLE_CONSTS = {
  initialPageSize: 20,
  pageSizeOptions: [5, 10, 20, 30, 40, 50, 100, 500] as number[],
} as const;

export const buildApiFilter = (
  filter: { id: string; value: any },
  filterVariant: string = "text"
) => {
  let apiFilter = "";
  if (!filter.value || (Array.isArray(filter.value) && filter.value.length < 1))
    return { id: filter.id, value: "", apiFilter: "" };

  if (isDateRangeFilter(filter.value, filterVariant)) {
    const filterFromDate = new Date(filter.value[0]);
    const fromDate = new Date(
      Date.UTC(
        filterFromDate.getFullYear(),
        filterFromDate.getMonth(),
        filterFromDate.getDate(),
        0,
        0,
        0,
        0
      )
    );
    const from = `${filter.id} ge ${fromDate.toISOString().slice(0, 19).replace("T", " ")}`;

    let to = "";
    if (filter.value.length > 1 && filter.value[1]) {
      const filterToDate = new Date(filter.value[1]);
      const toDate = new Date(
        Date.UTC(
          filterToDate.getFullYear(),
          filterToDate.getMonth(),
          filterToDate.getDate(),
          23,
          59,
          59,
          999
        )
      );
      to = `${filter.id} le ${toDate.toISOString().slice(0, 19).replace("T", " ")}`;
    }

    apiFilter = `${from}${to ? ` and ${to}` : ""}`;
  } else
    switch (filterVariant) {
      case "select":
        apiFilter = `${filter.id} in (${filter.value})`;
        break;
      case "text":
        apiFilter = `${filter.id} like '${filter.value}'`;
        break;
      case "id":
        apiFilter = `${filter.id} in (${filter.value})`;
        break;
      default:
        break;
    }

  return {
    id: filter.id,
    value: filter.value?.toString() ?? "",
    apiFilter,
  };
};

function isDateRangeFilter(
  filterValue: any,
  filterVariant: string
): filterValue is Date[] {
  return filterVariant === "date-range" && Array.isArray(filterValue);
}
